module.exports = __webpack_public_path__ + "media/images/landings/promotion_3/img_icon-02-1a320d42eb5345b3847948d57e6f286b.png";